/* istanbul ignore file */

import dynamic from 'next/dynamic';

import { TileCarouselSectionProps } from '../../../components/sections/TileCarouselSection';
import { SectionRenderer } from '../../../types/Section';
import { Transformer } from '../../../types/Transformer';
import { tiles } from './data';
import { FakeTileCarouselContentSection } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<TileCarouselSectionProps> =
  dynamic<TileCarouselSectionProps>(() =>
    import('../../../components/sections/TileCarouselSection').then(
      (mod) => mod.TileCarouselSection,
    ),
  );

export const transformer: Transformer<
  FakeTileCarouselContentSection,
  TileCarouselSectionProps
> = ({}) => ({
  uid: 'fake-uid',
  props: {
    tiles,
    title: 'Shop by department',
    trackingTitle: 'tile carousel',
  },
});
